<div class="field" (clickOutside)="clickOutside($event)">
  <mat-form-field [appearance]="appearance" [ngClass]="{'field-error': hasError}">
    <mat-label [ngClass]="{'input-error' : hasError}">{{ label }}</mat-label>
    <input matInput autocomplete="new-password" (focus)="touched = true" (focus)="showOptions = true"
     (blur)="checkErrors($event)" (keyup)="inputChanged()" (keyup)="showOptions = true"
      (keyup)="keyRestrictionFunction($event)" [type]="inputType" [formControl]="control" [placeholder]="placeholder"
      [maxLength]="maxLength" [ngClass]="{'input-error': hasError}"/>
  </mat-form-field>
  <span class="error-msg" *ngIf="hasError">{{ errorMessage }}</span>
  <img *ngIf="showImage && (displayOption !== 'countryRate')" class="validation-img" [src]="image" />

  <ul class="options" [ngClass]="{'options--scroll' : scroll}" *ngIf="showOptions">
    <li class="options--option" *ngFor="let option of filteredOptions" (mousedown)="optionSelected(option)">{{
      displayValue(option) }}</li>
  </ul>
</div>